import axiosInstance from '@/app/api/axiosInstance';
import {
  TaskSchedule,
  TaskScheduleCreate,
  TaskScheduleUpdate,
  TaskScheduleListResponse,
  GenerateTasksRequest,
  GenerateTasksResponse,
} from '@/app/types/taskSchedule';
import { ListQueryParams } from '@/app/types/api';

const API_PATH = '/task-schedules';

export const taskScheduleService = {
  list: async (params?: ListQueryParams & { party_id?: number; is_active?: boolean }): Promise<TaskScheduleListResponse> => {
    try {
      const response = await axiosInstance.get<TaskScheduleListResponse>(`${API_PATH}/`, {
        params,
      });
      return response.data;
    } catch (error) {
      console.error('Failed to list task schedules:', error);
      throw error;
    }
  },

  get: async (id: number): Promise<TaskSchedule> => {
    try {
      const response = await axiosInstance.get<TaskSchedule>(`${API_PATH}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Failed to get task schedule with ID ${id}:`, error);
      throw error;
    }
  },

  listForParty: async (partyId: number, params?: ListQueryParams): Promise<TaskScheduleListResponse> => {
    try {
      const response = await axiosInstance.get<TaskScheduleListResponse>(
        `${API_PATH}/party/${partyId}`,
        { params }
      );
      return response.data;
    } catch (error) {
      console.error(`Failed to list task schedules for party ${partyId}:`, error);
      throw error;
    }
  },

  create: async (data: TaskScheduleCreate): Promise<TaskSchedule> => {
    try {
      const response = await axiosInstance.post<TaskSchedule>(`${API_PATH}/`, data);
      return response.data;
    } catch (error) {
      console.error('Failed to create task schedule:', error);
      throw error;
    }
  },

  update: async (id: number, data: TaskScheduleUpdate): Promise<TaskSchedule> => {
    try {
      const response = await axiosInstance.patch<TaskSchedule>(`${API_PATH}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(`Failed to update task schedule with ID ${id}:`, error);
      throw error;
    }
  },

  delete: async (id: number): Promise<void> => {
    try {
      await axiosInstance.delete(`${API_PATH}/${id}`);
    } catch (error) {
      console.error(`Failed to delete task schedule with ID ${id}:`, error);
      throw error;
    }
  },

  generate: async (data: GenerateTasksRequest): Promise<GenerateTasksResponse> => {
    try {
      const response = await axiosInstance.post<GenerateTasksResponse>(
        `${API_PATH}/generate`,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Failed to generate tasks from schedules:', error);
      throw error;
    }
  },
};

export const listTaskSchedules = taskScheduleService.list;
export const getTaskSchedule = taskScheduleService.get;
export const listTaskSchedulesForParty = taskScheduleService.listForParty;
export const createTaskSchedule = taskScheduleService.create;
export const updateTaskSchedule = taskScheduleService.update;
export const deleteTaskSchedule = taskScheduleService.delete;
export const generateTasks = taskScheduleService.generate;
